import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { HeroStageContent } from './HeroStageContent';
import { useViewportContainers } from './HeroStageContent.config';
import { HeroStagePlaceholder } from './HeroStageOverlay.styles';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeroStage = ({
  medias
}) => {
  const containers = useViewportContainers();
  return /*#__PURE__*/_jsx(PlayContainer, {
    width: "full",
    sidePadding: {
      default: 0,
      mediaQuery: []
    },
    children: medias.length > 0 ? /*#__PURE__*/_jsx(HeroStageContent, {
      medias: medias
    }) : /*#__PURE__*/_jsx(Fragment, {
      children: containers.map(({
        aspectRatio,
        visibleViewport
      }) => /*#__PURE__*/_jsx(Placeholder, {
        visibleViewport: visibleViewport,
        children: /*#__PURE__*/_jsx(HeroStagePlaceholder, {
          aspectRatio: aspectRatio
        })
      }, visibleViewport))
    })
  });
};
const Placeholder = styled.div.withConfig({
  displayName: "HeroStage__Placeholder",
  componentId: "sc-6ezhji-0"
})(["display:none;", "{margin-bottom:60px;}", "{display:flex;}"], Viewports.for('mediumDown'), ({
  visibleViewport
}) => Viewports.for(visibleViewport));